import { useNavigate } from 'react-router-dom';
import { PAGE_ROUTE } from '~/constants';
import BackgroundImage from '~/assets/img/asset/subscription.png';
import * as S from './Subscription.styled';

export default function Subscription() {
  const navigate = useNavigate();

  return (
    <S.Container>
      <S.Background>
        <img src={BackgroundImage} alt='subscription_background' />
      </S.Background>
      <S.DescriptionWrapper direction='column' spacing={40}>
        <S.DescBox>
          <strong>
            UNLIMITED <br /> FULL ACCESS
          </strong>
          <span>You can get 3,000+ motion and items</span>
        </S.DescBox>
        <S.ButtonBox onClick={() => navigate(PAGE_ROUTE.SUBSCRIPTION_WAITING)}>
          <S.Button>Paid subscription</S.Button>
        </S.ButtonBox>
      </S.DescriptionWrapper>
    </S.Container>
  );
}
